export default "__VITE_ASSET__8nErDvso__"